import React from "react";
import { ThreeCircles } from "react-loader-spinner";

export default function ChartLoader({
    height = 60,
    width = 60,
    outerCircleColor = "#3498db",
    middleCircleColor = "#db213a",
    innerCircleColor = "#dec52d",
    position = "absolute",
    zIndex = 1055,
    top="50%",
    left="50%",
}) {
    return (
        <div
            style={{
                position: position,
                top: position === "absolute" ? top : undefined,
                left: position === "absolute" ? left : undefined,
                transform: position === "absolute" ? "translate(-50%, -50%)" : undefined,
                zIndex
            }}
        >
            <ThreeCircles
                height={height}
                width={width}
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor={outerCircleColor}
                middleCircleColor={middleCircleColor}
                innerCircleColor={innerCircleColor}
            />
        </div>
    );
}
